import { createComponent } from '@lit/react'
import * as React from 'react'

import Component from '../../components/card/card-title.component.js'

const tagName = 'dap-ds-card-title'

/**
 * `dap-ds-card-title`
 * @summary Title of the card
 * @element dap-ds-card-title
 * @title - Card title
 * @group card
 *
 * @property {'sm' |'md' | 'lg'} size - The size of the card title. Default is `sm`.
 * @property {boolean} noPadding - Whether the card title should have no padding.
 * @property {'top' | 'bottom' | 'both' | 'none'} spacing - The spacing of the card title. This adds a margin to the card title. Default is `top`.
 *
 * @slot - The content of the title.
 *
 * @csspart base - The main card title container.
 *
 * @cssproperty --dds-card-title-color - The text color of the card title. (default: var(--dds-color-text-primary))
 * @cssproperty --dds-card-title-font-weight - The font weight of the card title. (default: var(--dds-font-weight-bold))
 * @cssproperty --dds-card-title-line-height - The line height of the card title. (default: var(--dds-font-line-height-large))
 * @cssproperty --dds-card-title-margin-bottom - The bottom margin of the card title. (default: var(--dds-spacing-100))
 *
 * @cssproperty --dds-card-title-sm-padding-x - The horizontal padding for small size. (default: var(--dds-spacing-400))
 * @cssproperty --dds-card-title-sm-padding-bottom - The bottom padding for small size. (default: var(--dds-spacing-100))
 * @cssproperty --dds-card-title-sm-spacing-top - The top spacing for small size. (default: var(--dds-spacing-400))
 * @cssproperty --dds-card-title-sm-spacing-bottom - The bottom spacing for small size. (default: var(--dds-spacing-400))
 *
 * @cssproperty --dds-card-title-md-padding-x - The horizontal padding for medium size. (default: var(--dds-spacing-400))
 * @cssproperty --dds-card-title-md-padding-bottom - The bottom padding for medium size. (default: var(--dds-spacing-100))
 * @cssproperty --dds-card-title-md-spacing-top - The top spacing for medium size. (default: var(--dds-spacing-400))
 * @cssproperty --dds-card-title-md-spacing-bottom - The bottom spacing for medium size. (default: var(--dds-spacing-400))
 *
 * @cssproperty --dds-card-title-lg-padding-x - The horizontal padding for large size. (default: var(--dds-spacing-600))
 * @cssproperty --dds-card-title-lg-padding-bottom - The bottom padding for large size. (default: var(--dds-spacing-100))
 * @cssproperty --dds-card-title-lg-spacing-top - The top spacing for large size. (default: var(--dds-spacing-600))
 * @cssproperty --dds-card-title-lg-spacing-bottom - The bottom spacing for large size. (default: var(--dds-spacing-600))
 */
const reactWrapper = createComponent({
  tagName,
  elementClass: Component,
  react: React,
  events: {},
  displayName: 'DapDSCardTitle',
})

export default reactWrapper
